import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';


import { LayoutService } from '../../../@core/utils';
import { map, takeUntil,filter } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Router,NavigationStart,NavigationEnd,NavigationError, Event } from '@angular/router';
import { AuthService } from 'app/shared/services/auth.service';
import { AutoLogoutService } from 'app/shared/services/auto-logout.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { DialogService } from 'app/shared/services/dialog.service';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  
  username: string;
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Change Password' }, 
               { title: 'Log out' }
             ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              
              private authService: AuthService,
              private router :Router,
              //private autoLogoutService: AutoLogoutService,
              private dialogService : DialogService) {
  }

  ngOnInit() {
    this.getUserLoggedData();

    this.currentTheme = this.themeService.currentTheme;


    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.logout();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }


  logout() {
    this.menuService.onItemClick()
    .pipe(
      filter(({ tag }) => tag === 'my-context-menu'),
      map(({ item: { title } }) => title),
    )
    .subscribe(title =>  {
      if(title==='Log out'){
        this.authService.logoutUser();
        this.username = '';
       }else if(title==='Change Password'){
        this.router.navigate(['/change-password']);
       }    
    });
 
  }



  getUserLoggedData() : void {
    this.username = this.authService.getUserLoggedIn();
  }



}


